//
//
//
//

export default {
  name: 'CleanLayout',
}
